<template>
  <div class="scan-login">
    <div class="code-box" v-loading="codeLoading">
      <img class="wh100" :src="codeUrl" v-if="codeUrl" />
      <div class="mask-box" v-if="scanRespStt && scanRespStt != '未扫码'">
        <span
          class="tips danger"
          v-if="['已过期', '已取消'].includes(scanRespStt)"
        >
          <span v-if="scanRespStt == '已过期'">二维码已过期</span>
          <span v-if="scanRespStt == '已取消'">用户取消授权</span>
          <span class="freash-btn el-icon-refresh" @click.stop="refresh"
            >刷新</span
          >
        </span>
        <span
          class="tips success"
          v-else-if="['已扫码', '已授权'].includes(scanRespStt)"
        >
          <span v-if="scanRespStt == '已扫码'">
            <span class="el-icon-success success-icon"></span>
            <span> 已扫码,请在小程序上<br />授权登录</span></span
          >
          <span v-else-if="scanRespStt == '已授权'"> 登录成功 </span>
        </span>
      </div>
    </div>
    <div class="scan-login-tips">微信扫码登录注册</div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  name: "scan-login",
  data: function () {
    return {
      codeLoading: false,
      code: {
        base64: "",
        scene: "",
      },
      scanResp: {
        status: "未扫码",
        user_token: null,
        new_user: false,
      },
      timer: null,
      timerLimit: 3000,
    };
  },
  computed: {
    codeUrl() {
      /* @/assets/img/temp-login-code.png */
      if (this.code.base64) return "data:image/png;base64," + this.code.base64;
      return "";
    },
    scanRespStt() {
      return this.scanResp.status;
    },
  },
  methods: {
    ...mapMutations("user", ["SET_TOKEN"]),
    startTimer() {
      this.timer = setInterval(this.fetchCodeStatus, this.timerLimit);
    },
    clearTimmer() {
      this.timer && clearInterval(this.timer);
      this.timer = null;
    },
    async fetchCodeStatus() {
      try {
        const params = { scene: this.code.scene };
        const resp = await this.$fetch({
          url: "/Wechat/getWxCodeStatus",
          unShowErrorTip: true,
          method: "GET",
          params,
        });
        const { state, data } = resp;
        if (state !== 0) return;
        this.scanResp = data || {};
        this.dispatchEvent(this.scanResp);
      } catch (error) {
        /*  */
      }
    },
    async fetchScanCode() {
      try {
        this.codeLoading = true;
        const url = this.$IS_DEV
          ? "/Wechat/GetWXACode"
          : "/Wechat/getWxLoginCode";
        const resp = await this.$fetch({
          url,
          method: "GET",
          unShowErrorTip: true,
        });
        this.codeLoading = false;
        const { state, data } = resp || {};
        if (state !== 0) return;
        const { code_base, scene } = data || {};
        this.code = { base64: code_base, scene };
        this.startTimer();
      } catch (error) {
        this.codeLoading = false;
      }
    },
    dispatchEvent(scanResp) {
      scanResp = scanResp || this.scanResp;
      const { status, user_token: token, new_user: newUser } = scanResp;
      const returnList = ["已过期", "已取消"];
      if (returnList.includes(status)) return this.clearTimmer();
      if (status == "已授权") {
        this.SET_TOKEN(token);
        this.$emit("afterLogin", newUser);
        this.$message.success("登录成功");
        this.clearTimmer();
      }
    },
    refresh() {
      this.clearTimmer();
      this.init();
    },
    init() {
      this.code = {
        base64: "",
        scene: "",
      };
      this.scanResp = {
        status: "未扫码",
        user_token: null,
        new_user: false,
      };
      this.fetchScanCode();
    },
  },
  created() {
    this.init();
  },
  beforeDestroy() {
    this.clearTimmer();
  },
};
</script>
<style lang="scss" scoped>
.scan-login {
  .code-box {
    width: 200px;
    height: 200px;
    margin-bottom: 26px;
    position: relative;
    border-radius: 10px;
    overflow: hidden;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 5px 10px rgba(0, 0, 0, 0.05);
    .mask-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.96);
      text-align: center;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .tips {
        font-size: 14px;
        &.danger {
          color: var(--color-danger);
        }
        &.success {
          color: var(--color-success);
        }
        .success-icon {
          font-size: 56px;
          display: block;
          margin-bottom: 5px;
        }
      }
      .freash-btn {
        cursor: pointer;
        color: var(--color-primary);
        margin-left: 0.5em;
      }
    }
  }
  .scan-login-tips {
    font-size: 16px;
    color: #303133;
    text-align: center;
  }
}
</style>
